module.exports = __webpack_public_path__ + "img/Skirt-Front-B2-Db-Ge-Ha-Ia.37a96516.png";